import * as React from 'react';
import { mergeStyles } from '@cian/utils';

import { chartHeight } from '../../constants';
import { ChartLegend } from '../ChartLegend';
import { IChartLegend } from '../../types';

import * as styles from './styles.css';

export interface IChartProps {
  chartCanvasRef: React.RefObject<HTMLCanvasElement>;
  chartLegend: IChartLegend;
}

export const Chart: React.FC<IChartProps> = ({ chartCanvasRef, chartLegend }) => {
  return (
    <>
      <div className={styles['legend']}>
        <ChartLegend chartLegend={chartLegend} />
      </div>
      <div {...mergeStyles(styles['chart'], { height: chartHeight })}>
        <canvas ref={chartCanvasRef} />
      </div>
    </>
  );
};

Chart.displayName = 'Chart';
